/*
 * Mini-cart Enova (snippets/cart-drawer.liquid), adaptado de carolina-store.
 * - Apertura: refleja el estado de cart.js en .is-open; la hoja de pre-checkout
 *   (enova-minicart-checkout.js) lo usa para cerrarse con el drawer y precargarse al abrirlo.
 * - ?cart=open en la URL (así redirige /cart, ver layout/theme.liquid) abre el drawer al cargar.
 */
(() => {
  class EnovaMinicart {
    constructor(root) {
      this.root = root;
      this.watchOpenState();
      this.openFromUrl();
    }

    // /cart redirige al inicio con ?cart=open: se abre el drawer y se quita el parámetro para
    // que no vuelva a abrirse al recargar o al compartir la URL.
    openFromUrl() {
      const url = new URL(window.location.href);
      if (url.searchParams.get('cart') !== 'open') return;
      url.searchParams.delete('cart');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);

      customElements.whenDefined('m-cart-drawer').then(() => {
        requestAnimationFrame(() => {
          if (typeof this.root.open === 'function') this.root.open();
        });
      });
    }

    // cart.js abre y cierra solo con --translate-x: se refleja en .is-open.
    watchOpenState() {
      const root = this.root;
      const sync = () => {
        root.classList.toggle('is-open', root.style.getPropertyValue('--translate-x').trim() === '0');
      };
      new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['style', 'class'] });
      sync();
    }
  }

  function init() {
    document.querySelectorAll('.enova-minicart').forEach((root) => {
      if (root.dataset.enovaMinicartReady === 'true') return;
      root.dataset.enovaMinicartReady = 'true';
      new EnovaMinicart(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
